import { Homepage } from "@/containers/homepage";
import { WebLayout } from "@/components/shared/layout/homepage";

export function HomepagePage() {
  return (
    <WebLayout>
      <Homepage />
    </WebLayout>
  );
}
